import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { Grid, Avatar, Button } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';

import ReactLoading from 'react-loading';

import { login, getUser, getUserAgency, getAllAgencies } from '../API';

import { useTranslation } from "react-i18next";

import Cookies from "js-cookie";

const Login = () => {

  const [isCookieSet, setCookie] = useState(Cookies.get("cookieConsent"));
  const [showConsent, setShowConsent] = useState(false);

  const [t] = useTranslation('common');

  const navigate = useNavigate();

  const avatarStyle = { backgroundColor: '#4d0077' }
  const btnstyle = { margin: '8px 0' }

  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');

  const [agencies, setAgencies] = useState('');
  const [agency, setAgency] = useState('rtl');
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);

  const [loading, setLoading] = useState(0);

  useEffect(() => {

    getUser()
      .then((response) => {
        if (response.user) {
          setUser(response.user);
          sessionStorage.setItem('authed', JSON.stringify(true));
          getUserAgency()
            .then((response) => {
              setAgency(response);
            }).then(() => {
              setSuccess(true);
              setLoading(0);
              navigate("/home");
            })
        }
      })

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })

  }, []);


  useEffect(() => {
    setErrMsg('');
  }, [user, pwd]);


  // Function to get existing consent cookie
  useEffect(() => {

    if (!Cookies.get("cookieConsent")) {
      setShowConsent(true)
    }

  }, [])


  const handleSubmit = async (e) => {

    setLoading(1);
    e.preventDefault();
    let setLogin = await login(user, pwd);

    if (setLogin.status !== 200) {
      setErrMsg(1)
      setLoading(0);
    } else {

      setSuccess(true);
      setUser('');
      setPwd('');
      sessionStorage.setItem('authed', JSON.stringify(true));
      location.reload();

    }
  }

  // Function to handle accepting cookies
  const handleAcceptCookies = () => {
    Cookies.set("cookieConsent", true, { expires: 365 });
    setCookie(true);
    setShowConsent(false);
  };


  // Function to handle rejecting cookies
  // const handleRejectCookies = () => {
  //   Cookies.remove("cookieConsent");
  //   setCookie(false);
  // };


  return user && success == true ? (

    <>

      <div></div>

    </>
  ) :
    (
      <>

        {loading == 0 ? '' :
          <div className="ponctualitespinner">
            <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
          </div>}

        <div className="container" style={{ backgroundColor: "#ffffff" }}>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-12 pt-5">
              <div className="shadow p-3 mb-5 bg-body rounded">
                <Grid align='center'>
                  <Avatar style={avatarStyle}><LockOutlinedIcon /></Avatar>
                  <h2 className="pt-2 pb-2">Bus RT Insights</h2>
                </Grid>
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="pb-2">
                    <input
                      id="username"
                      className="form-control form-control-lg"
                      type="text"
                      onChange={(e) => { setUser(e.target.value) }}
                      placeholder={t("login.user")}
                      aria-label="usager"
                      value={user}
                    />
                  </div>
                  <div className="pt-2 pb-2">
                    <input
                      id="password"
                      className="form-control form-control-lg"
                      type="password"
                      onChange={(e) => { setPwd(e.target.value) }}
                      placeholder={t("login.pass")}
                      value={pwd}
                    />
                  </div>
                  <Button type='submit' color='primary' variant="contained" style={btnstyle} fullWidth>{t('login.connect')}</Button>
                </form>
              </div>
            </div>

          </div>

          <div className="row justify-content-center">
            <div className="col-lg-4 text-center">
              <div className="alert alert-danger" role="alert" style={{ visibility: errMsg !== '' ? "visible" : "hidden" }}>
                {t("login.error")}
              </div>
            </div>
          </div>

        </div>

        {showConsent == true ?
          <div className="row fixed-bottom border align-items-center pt-3 pb-3" style={{ backgroundColor: "black", color: "white" }}>
            <div className="col-lg-10 col-12 pb-2">
              <div className="container">{t('login.cookie')}</div>
            </div>
            <div className="col-lg-2 col-12 text-center">
              <div className="btn btn-light" onClick={handleAcceptCookies}>{t('login.accept')}</div>
            </div>
          </div> : ''}

      </>
    );


}

export default Login;